import clone from 'clone'
import http from '@/utils/ajax'
import { TARIFF_BENEFITS_INIT_LOADING, TARIFF_BENEFITS_INIT_SUCCESS, TARIFF_BENEFITS_INIT_FAIL } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

export const initialState = {
  // Agency level init (bring in menu for specific modules eg: travel motor etc)
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {}
}

const getters = {

}

const mutations = {
  [TARIFF_BENEFITS_INIT_LOADING](state, err) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [TARIFF_BENEFITS_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [TARIFF_BENEFITS_INIT_FAIL](state, err) {
    state.init = 2
    state.initErr = err
    state.menu = {}
  }
}

const actions = {
  async tarfBenManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.tarfBenManagementController
    commit(TARIFF_BENEFITS_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(TARIFF_BENEFITS_INIT_SUCCESS, commitResult)
    } catch (err) {
      commit(TARIFF_BENEFITS_INIT_FAIL, extractMessages(err))
    }
  }
}

export default {
  state: clone(initialState),
  getters,
  mutations,
  actions
}
